import { render, staticRenderFns } from "./articles_panel.vue?vue&type=template&id=449ff76b"
import script from "./articles_panel.vue?vue&type=script&lang=js"
export * from "./articles_panel.vue?vue&type=script&lang=js"
import style0 from "./articles_panel.vue?vue&type=style&index=0&id=449ff76b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports